import React, { useEffect, useState } from "react";

export default function ConversationNicknameSection({
  mode,
  dmPeerUsername,
  dmNickname,
  onSaveDmNickname,
  groupMembers = [],
  currentUserId,
  nicknamesByUserId = {},
  onSaveGroupNickname,
  disabled,
}) {
  const [dmVal, setDmVal] = useState("");
  const [groupDrafts, setGroupDrafts] = useState({});

  useEffect(() => {
    setDmVal(dmNickname || "");
  }, [dmNickname]);

  useEffect(() => {
    const next = {};
    groupMembers.forEach((m) => {
      if (Number(m.user_id) === Number(currentUserId)) return;
      const nid = Number(m.user_id);
      next[nid] = nicknamesByUserId[nid] ?? nicknamesByUserId[m.user_id] ?? "";
    });
    setGroupDrafts(next);
  }, [groupMembers, nicknamesByUserId, currentUserId]);

  if (mode === "dm") {
    return (
      <div>
        <h3 className="text-[13px] font-semibold text-white/90 mb-2">Nickname</h3>
        <p className="text-[12px] text-white/45 mb-3">
          A private label for <span className="text-white/70">{dmPeerUsername || "this chat"}</span>{" "}
          — only you see it here.
        </p>
        <input
          type="text"
          value={dmVal}
          onChange={(e) => setDmVal(e.target.value)}
          maxLength={64}
          placeholder="e.g. Best friend"
          disabled={disabled}
          className="w-full rounded-xl border border-white/12 bg-white/[0.04] px-3 py-2.5 text-[13px] text-white placeholder:text-white/35 outline-none focus:ring-2 focus:ring-white/20"
        />
        <button
          type="button"
          disabled={disabled}
          onClick={() => onSaveDmNickname(dmVal.trim())}
          className="mt-3 w-full rounded-xl border border-white/14 bg-white/[0.06] py-2.5 text-[13px] font-medium text-white hover:bg-white/[0.1] transition disabled:opacity-50"
        >
          Save nickname
        </button>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-[13px] font-semibold text-white/90 mb-2">Nicknames</h3>
      <p className="text-[12px] text-white/45 mb-3">
        Set how each member appears to you in this group (only on your device / your account).
      </p>
      <div className="space-y-3 max-h-[220px] overflow-y-auto fc-scroll pr-1">
        {groupMembers
          .filter((m) => Number(m.user_id) !== Number(currentUserId))
          .map((m) => {
            const id = Number(m.user_id);
            return (
              <div key={id} className="rounded-xl border border-white/10 bg-white/[0.03] p-3">
                <div className="text-[11px] text-white/50 mb-1">@{m.username}</div>
                <input
                  type="text"
                  value={groupDrafts[id] ?? ""}
                  onChange={(e) =>
                    setGroupDrafts((prev) => ({ ...prev, [id]: e.target.value }))
                  }
                  maxLength={64}
                  placeholder="Nickname"
                  disabled={disabled}
                  className="w-full rounded-lg border border-white/12 bg-black/20 px-2.5 py-2 text-[13px] text-white placeholder:text-white/35 outline-none focus:ring-1 focus:ring-white/25"
                />
                <button
                  type="button"
                  disabled={disabled}
                  onClick={() => onSaveGroupNickname(id, (groupDrafts[id] || "").trim())}
                  className="mt-2 text-[12px] font-medium text-[#9cc8e8] hover:text-white transition"
                >
                  Save for this member
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}
